import { RootState } from "../../../store";
import { resourceExplorerStateSelector } from "../resourceExplorerStateSelector";
import { FilterTreeNodeWithId } from "../../../../components/pages/common/filters-tree/utils/types/common";

export const resourceExplorerFilterTreeSelector = (
  state: RootState,
): FilterTreeNodeWithId | undefined => {
  return resourceExplorerStateSelector(state).filterTree;
};
